import { useNavigate } from 'react-router-dom';
import './App.css';
import MarketingMenuItem from "./MarketingMenuItem";
import PageMarketingV2GDPR from './PageMarketingV2GDPR';

function PageMarketingV2Menu() {
    const navigate = useNavigate();

    return (
        <div>
            <div
                className='mk2-menu'
            >
                <div
                    onClick={
                        () => {
                            navigate('/');
                        }
                    }
                >
                    <MarketingMenuItem
                        title='Home'
                    />
                </div>
                <div
                    onClick={
                        () => {
                            navigate('/gallery');
                        }
                    }
                >
                    <MarketingMenuItem
                        title='Gallery'
                    />
                </div>
                <div
                    onClick={
                        () => {
                            navigate('/v2/pricing');
                        }
                    }
                >
                    <MarketingMenuItem
                        title='Pricing'
                    />
                </div>
                <div
                    onClick={
                        () => {
                            navigate('/login');
                        }
                    }
                >
                    <MarketingMenuItem
                        title='Login'
                    />
                </div>
            </div>
        </div>
    )
}

export default PageMarketingV2Menu;